<template>
    <div class="realTimeInfo-box" id="realTimeInfo-box">
      <div class="real-box">
        <img class="real-title-img" src="@/assets/image/consultService/subscribe.png" @click="showViewPopup = true">
        <div class="real-banner-box">
          <div class="real-banner">
            <swiper ref="mySwiper" :options="swiperOption">
              <swiper-slide v-for='item in page' :key='item.id'>
                <ul class="s-grid-box">
                  <li v-for="page in item" :key="page.id" class="s-grid-content" :class="{active:page.newKey == activeTab}" @click="activeTab = page.newKey">
                    <p>{{ page.newName }}</p>
                  </li>
                </ul>
              </swiper-slide>
            </swiper>
            <!-- 左右导航栏 -->
            <div class="swiper-button-prev swiper_btn1" slot="button-prev"></div>
            <div class="swiper-button-next swiper_btn2" slot="button-next"></div>
          </div>
        </div>
      </div>
      <!--  轮播图  -->
      <SwipeBanner :data="bannerObj"></SwipeBanner>
      <!--消息-->
      <div>
        <div v-for="(item,index) in  newsList" :key="index" @click="clickHandle(item)">
          <div class="new-box">
            <div class="new-title">{{item.title}}</div>
            <div class="new-content">
              <!--<img src="@/assets/image/consultService/new.jpg">-->
              <div class="new-message"></div>
              <div class="new-time" v-if="item.pubDate">
                <img src="@/assets/image/consultService/new.jpg">
                {{item.pubDate}}
              </div>
              <div class="new-views"></div>
            </div>
          </div>
        </div>
      </div>
      <!--订阅弹框-->
      <van-popup v-model="showViewPopup" position="right" :style="{ width: '70%',height:'100%' }" >
        <div class="view-box">
          <div class="view-title">我的订阅</div>
          <div class="mine-view" >
            <div class="my-tab" v-for="(item,index) in  tabList" :key="index">
              <div class="tab-name">{{item.newName}}</div>
              <div class="del-icon" @click="delTab(item.newKey)">×</div>
            </div>
          </div>
          <div class="view-title">所有通知</div>
          <div class="mine-view" >
            <div class="my-tab" v-for="(item,index) in  tabAllList" :key="index"
                 :class="{checked:item.checked}" @click="addTab(item)">
              <div class="tab-name">{{item.name}}</div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </template>
  
  <script>
    import { baseURL } from "@/utils/url";
    import {getNews,getAllNews,queryTitleOfNews,getBanner,delNews,modifyNews} from "@/api/home";
    // 可以直接在组件里引入这个文件
    import { swiper, swiperSlide } from  'vue-awesome-swiper';
    export default {
      name: "realTimeInfo",
      components: {
        swiper,swiperSlide,
        SwipeBanner: () => import("@/components/Home/SwipeBanner"),
      },
      computed:{
        page(){
          let pages = [];
          this.tabList.forEach((item,index)=>{
            let idx = Math.floor(index/4)
            if(!pages[idx]) pages[idx] =[];
            pages[idx].push(item)
          })
          return pages
        }
      },
      data(){
        return {
          showViewPopup:false,
          basePath: baseURL,
          swiperOption:{
            //  前进后退按钮
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
            }
          },
          activeTab: '',
          allActiveTab:'',
          tabList: [],
          tabAllList:[],
          newsList: [],
          bannerObj: {
            intervalTime: 3000,
            autoSwitch: false,
            items: []
          },
        }
      },
      mounted(){
        this.get();
      },
      methods: {
        async delTab(key){
          await delNews(key).then(res=>{
            this.$toast.success('删除成功');
            if(this.tabList.length == 1){
              this.activeTab = '';
              this.tabList = [];
              this.newsList = [];
          }else{
              this.tabList = this.tabList.filter(item=>item.newKey != key);
              this.activeTab = this.tabList[0].newKey;
            }
          })
          await this.getNews();
          await this.judge();
        },
        async addTab(item){
          await modifyNews({
            newKey: item.key,
            newId: item.id,
            newUrl: item.url,
            newOpenType: item.opentype,
            newName: item.name
          }).then(res=>{
          })
          await this.getNews();
          await this.judge();
        },
        clickHandle(item){
          window.open(item.uri)
        },
        async get() {
          getBanner().then(res => {
            if (res.code && res.code == 200) {
              this.bannerObj.autoSwitch = Boolean(res.data.autoSwitch) || true;
              this.bannerObj.intervalTime = parseInt(res.data.intervalTime) || 3000;
              this.bannerObj.items = res.data.items;
            }
          });
          await getAllNews().then(resp => {
            if (resp.length>0) {
              this.tabAllList = resp;
            }
          });
          await this.getNews();
          await this.judge();
        },
        async getNews(){
          await getNews().then(resp => {
            if (resp && resp.data.length>0) {
              this.tabList = resp.data;
              this.activeTab = this.tabList[0].newKey;
            }
          });
        },
        judge(){
          var list = this.tabList.map((item,index)=>{
            return item.newKey
          })
          this.tabAllList = this.tabAllList.map((item,index)=>{
            return {...item,checked:list.includes(item.key)}
          })
          console.log(this.tabAllList)
        }
      },
      watch:{
        activeTab(newVal,oldVal){
          queryTitleOfNews(newVal).then(res =>{
            if (res){
              for (var i=0;i<res.length;i++){
                if (res[i].pubDate){
                  var time = new Date(res[i].pubDate);
                  var y = time.getFullYear();
                  var m = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
                  var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                  res[i].pubDate = y + '-' + m + '-' + d;
                }
              }
            }
            this.newsList = res;
          })
        }
      }
    }
  </script>
  
  <style lang="scss" scoped>
    @import '~@/assets/css/theme/theme.scss';
    .real-title-img{
      position: absolute;
      width: 27px;
      height: 17px;
      right: 10px;
      top: 13px;
      opacity: 0.8;
    }
    .real-box{
      background: #e7e7e7;
    }
    .real-banner-box{
      width: 90%;
  
    }
    .real-banner{
      height: 45px;
      width: 90%;
      margin: auto;
      display: flex;
      align-items: center;
      position: relative;
    }
    .s-grid-box {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 10px;
    }
    .s-grid-content {
      position: relative;
      width: 20%;
      height: 40px;
      padding: 7px;
      box-sizing: border-box;
      text-align: center;
      flex: 0 0 25%;
      p {
        height: 20px;
        margin-top: 6px;
        color: $c333;
        line-height: 20px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @extend .font14;
      }
    }
    .active{
      font-weight: bold;
      color: #3E3E3E;
    }
    .active :after{
      display: block;
      clear: both;
      content: '';
      width: 22px;
      height: 3px;
      background: var(--main-color);
      border-radius: 2px;
      position: absolute;
      top: 35px;
      left: 26px;
    }
    .swiper_btn1,.swiper_btn2{
      color: #a4a4a4;
      height: 20px;
    }
    ::v-deep .swiper-slide{
      width: 100%!important;
    }
    ::v-deep .swiper-container{
      width: 100%!important;
    }
    ::v-deep .swiper-button-prev{
      left: -5%;
      top: 68%;
    }
    ::v-deep .swiper-button-next{
      right: -5%;
      top: 68%;
    }
    ::v-deep .swiper-button-prev:after, ::v-deep .swiper-button-next:after{
      font-size: 14px !important;
      font-weight: bold;
    }
    .new-box{
      padding: 15px 10px;
      border-top: 1px solid #e8e8e8;
      border-bottom: 1px solid #e8e8e8;
      line-height: 22px;
    }
    .new-title{
      color: $c333;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 这里是超出几行省略 */
      overflow: hidden;
      @extend .font14;
    }
    .new-content{
      display: flex;
      flex-direction: row;
      align-items: center;
      img{
        margin-top: -5px;
        width: 35px;
        margin-right: 10px;
      }
    }
    .new-message{
      margin-right: 10px;
      color: #808080;
      @extend .font12;
    }
    .new-time{
      color: #808080;
      @extend .font11;
    }
    .new-views{
      color: var(--main-color);
      flex: 1;
      display: flex;
      justify-content: flex-end;
      @extend .font11;
    }
    ::v-deep .van-popup{
      background: url("../../assets/image/consultService/viewBac.jpg")no-repeat center;
      background-size: 100% 100%;
    }
    .view-box{
  
    }
    .view-title{
      font-size: 15px;
      font-weight: bold;
      color: #333333;
      padding:20px 0 0 15px;
    }
    .mine-view{
      padding: 15px 10px 0;
      display: flex;
      flex-wrap: wrap;
    }
    .my-tab{
      position: relative;
      width: 30%;
      font-size: 12px;
      margin: 0 3px 6px;
      display: flex;
      flex: 0 0 30%;
      justify-content: center;
      align-items: center;
      height: 30px;
      background: #F9F9F9;
      border-radius: 5px;
      border: 1px solid #DDDDDD;
    }
    .checked{
      border: 1px solid var(--main-color);
      background: var(--main-color);
      color: var(--sub-color)
    }
    .del-icon{
      position: absolute;
      top: 2px;
      left: 2px;
      div{
        color: #333333;
        width: 6px;
        height: 6px;
      }
    }
  </style>
  